import type { OperationRoute } from '../types'

/**
 * La RUTA que cobra un viaje de volqueta.
 *
 * Espejo de `retri-app-horometros/src/utils/tripRoute`. Vive fuera de la
 * pantalla porque decide PLATA: elegir mal cobra el viaje a otra tarifa, y eso
 * no se descubre hasta cuadrar el acta.
 */
export interface RouteChoice {
  needsPick: boolean
  options: OperationRoute[]
  preselected: number | null
}

export function routeChoice(
  routes: OperationRoute[] | null | undefined,
  assetGroupId?: number | null,
): RouteChoice {
  const options = (routes || []).filter((r) => r && typeof r.id === 'number')

  // Con una sola ruta no se pregunta: esa ruta ES el grupo por defecto del
  // equipo, así que elegirla no cambiaría nada.
  if (options.length <= 1) {
    return { needsPick: false, options, preselected: null }
  }

  const preselected = assetGroupId && options.some((r) => r.id === assetGroupId)
    ? assetGroupId
    : null

  return { needsPick: true, options, preselected }
}

export function routeLabel(route: OperationRoute): string {
  const de = route.loadingZone?.trim() || '—'
  const a = route.unloadingZone?.trim() || '—'
  return `${de} → ${a}`
}

/**
 * Elegir una ruta y dejar escritas las zonas de otra daría una remisión que se
 * contradice: dice un recorrido y cobra otro.
 */
export function zonesForRoute(route: OperationRoute | undefined | null): {
  loadingZone: string
  unloadingZone: string
} | null {
  if (!route) return null
  return {
    loadingZone: route.loadingZone?.trim() || '',
    unloadingZone: route.unloadingZone?.trim() || '',
  }
}
